import React, { useEffect, useState } from 'react';

import { useConfig } from 'Context/ConfigContext';
import useGetDeviceInfo from 'Util/Hooks/useGetDeviceInfo';

import { TextTitle, TextSubTitle, TextDescription } from '../Components/TextContent';
import { CardWrapper, ContentWrapper } from '../Components/WrapperContent';

const UserDevice = () => {
  const { appVersion: appVersionConfig } = useConfig();
  const {
    appVersion,
    appBuild,
    model,
    operatingSystem,
    osVersion,
    platform: devicePlatform,
    uuid,
  } = useGetDeviceInfo();

  // FIXME: For workaround appVersion from Capacitor when contextIsolation is true
  const [electronAppVersion, setElectronAppVersion] = useState(null);
  const isElectron = !!window.electron?.isElectron;

  useEffect(() => {
    let isMounted = true;

    if (isElectron) {
      window.electron.getAppVersion().then((version) => {
        if (isMounted) {
          setElectronAppVersion(version);
        }
      });
    }

    return () => {
      isMounted = false;
    };
  }, [isElectron]);

  const platform = isElectron ? window.electron.platform : devicePlatform;
  const currentVersion = isElectron ? electronAppVersion : appVersion;
  const versionNo = currentVersion || appVersionConfig;

  const userAgent = window.navigator.userAgent ?? '-';
  const modelOS = model && operatingSystem ? `${model} (${operatingSystem})` : '-';
  const buildNo = appBuild ? `(Build ${appBuild})` : '';
  const versionApp = `${versionNo} ${buildNo}`.trim();

  return (
    <>
      <TextTitle mt={8}>อุปกรณ์ผู้ใช้</TextTitle>
      <ContentWrapper gridTemplateColumns={'1fr'}>
        <CardWrapper>
          <TextSubTitle>ข้อมูลอุปกรณ์</TextSubTitle>
          <TextDescription>{userAgent}</TextDescription>
        </CardWrapper>
      </ContentWrapper>

      <ContentWrapper>
        <CardWrapper>
          <TextSubTitle>แอปเวอร์ชัน</TextSubTitle>
          <TextDescription>{versionApp}</TextDescription>
        </CardWrapper>
        <CardWrapper>
          <TextSubTitle>ระบบปฎิบัติการ</TextSubTitle>
          <TextDescription>{osVersion ?? '-'}</TextDescription>
        </CardWrapper>
      </ContentWrapper>

      <ContentWrapper>
        <CardWrapper>
          <TextSubTitle>โมเดล</TextSubTitle>
          <TextDescription>{modelOS}</TextDescription>
        </CardWrapper>
        <CardWrapper>
          <TextSubTitle>UUID</TextSubTitle>
          <TextDescription>{uuid ?? '-'}</TextDescription>
        </CardWrapper>
      </ContentWrapper>

      <ContentWrapper>
        <CardWrapper>
          <TextSubTitle>แพลตฟอร์ม</TextSubTitle>
          <TextDescription>{platform ?? '-'}</TextDescription>
        </CardWrapper>
      </ContentWrapper>
    </>
  );
};

export default UserDevice;
